import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa6";
import VehicleBadge from "./VehicleBadge";
import VehicleRight from "./VehicleRight";
import { indianNumberFormat } from "../../../utils/handlers";
import { truncateText } from "../../../utils/handlers";
import axios from "axios";
import ImageLoading from "../../../components/ImageLoading";
import carImage from "../../../images/Car.png";
import bikeImage from "../../../images/bikethumbnail.png";

function IndividualVehicle({ selectedVehicle, id, setSingleVehicleView }) {
  const token = localStorage.getItem("token");
  const [response, setResponse] = useState();
  const [loading, setLoading] = useState(false);
  const fetchVehicleData = async () => {
    setLoading(true);
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/get_vehicle_details/${selectedVehicle.id}?user_id=${id}`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      if (res?.data?.response !== null) {
        setResponse(res.data.response);
      } else {
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVehicleData();
  }, []);

  return (
    <>
      {loading && (
        <div className="w-full h-[calc(100vh-185px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <ImageLoading />
        </div>
      )}
      {!loading && (
        <div className=" h-[calc(100vh-185px)] mt-4 rounded-lg w-full bg-white p-4">
          <button
            onClick={() => setSingleVehicleView(false)}
            className="text-[#00394d] text-sm font-bold flex items-center"
          >
            <span className=" mr-2">
              <FaArrowLeft style={{ width: "18px", height: "18px" }} />
            </span>
            Back
          </button>
          <div className="flex mt-3">
            <div className="  min-w-[375px]  mx-4">
              {/* box div */}
              <div className=" border border-1 border-[#e6ebed] rounded-lg  p-4">
                <div className=" flex border-b border-[#e6ebed] pb-4">
                  <div
                    className={` w-14 h-14 rounded-full ${
                      response?.category === "Bike"
                        ? "bg-white"
                        : "bg-[#f0f9ff]"
                    }  flex justify-center items-center`}
                  >
                    <img
                      src={response?.category === "Bike" ? bikeImage : carImage}
                      alt=""
                    />
                  </div>
                  <div className="ml-4 flex flex-col justify-between h-14 text-lg font-bold">
                    <p className=" text-[#333333]">
                      {truncateText(response?.model_name, 25)}
                    </p>
                    <p className=" ">
                      ₹{" "}
                      {response?.collateral_value &&
                        indianNumberFormat(response?.current_price)}
                    </p>
                  </div>
                </div>
                {/* All details */}

                <div className="pt-4">
                  <VehicleBadge vehicle={response} />
                </div>
              </div>
            </div>
            <div className="  w-full  flex-grow h-fit">
              <VehicleRight response={response} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default IndividualVehicle;
